(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsEditWebinarController', CmsEditWebinarController);

  /* ngInject */
  function CmsEditWebinarController($state, $stateParams, $timeout, Flash, categoryService, cmsBucketService, cmsWebinarService, config, formErrorsService, publishedStatuses, sessionService, Upload) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.bucketTitle = null;
    vm.buckets = [];
    vm.categories = [];
    vm.createBucket = createBucket;
    vm.deleteVideo = deleteVideo;
    vm.deleteWebinar = deleteWebinar;
    vm.getCategories = getCategories;
    vm.getWebinar = getWebinar;
    vm.publishedStatuses = publishedStatuses;
    vm.removeAttachment = removeAttachment;
    vm.saveTopics = saveTopics;
    vm.updateWebinar = updateWebinar;
    vm.uploadAttachment = uploadAttachment;
    vm.uploadVideo = uploadVideo;
    vm.uploadVideoProgress = 0;
    vm.videoUploading = false;
    vm.webinar = {};
    vm.webinarForm = {};

    vm.activate();

    function activate() {
      getBuckets();
      getCategories();
      getWebinar();
    }

    function createBucket() {
      let bucket = {
        title: vm.bucketTitle,
        resource_type: 'webinar'
      };

      cmsBucketService(sessionService.getAuthToken()).save(bucket, response => {
        vm.buckets.push(response);
        vm.webinar.bucket_id = response.id;
        vm.bucketTitle = null;
        Flash.create('success', 'Bucket successfully created.');
      }, error => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
        vm.setFormErrors(vm.webinarForm, error);
      });
    }

    function getBuckets() {
      cmsBucketService(sessionService.getAuthToken()).query({ resource_type: 'webinar' }, response => vm.buckets = response);
    }

    function deleteVideo() {
      cmsWebinarService(sessionService.getAuthToken()).removeVideo({id: $stateParams.id}, _deleteVideoSuccess, _deleteVideoFailure);
    }

    function deleteWebinar() {
      angular.element('#deleteWebinarModal').modal('hide');
      cmsWebinarService(sessionService.getAuthToken()).delete({id: $stateParams.id}, _deleteWebinarSuccess, _deleteWebinarFailure);
    }

    function getCategories() {
      categoryService(sessionService.getAuthToken()).query({include: 'topics'}, response => vm.categories = response);
    }

    function getWebinar() {
      cmsWebinarService(sessionService.getAuthToken()).get({ id: $stateParams.id }, response => {
        vm.webinar = response;
        if (response.bucket) {
          vm.webinar.bucket_id = response.bucket.id;
        }
      });
    }

    function removeAttachment(webinar, attachment) {
      cmsWebinarService(sessionService.getAuthToken()).deleteAttachment({id: webinar.id, attachmentId: attachment.id},
        () => {
          Flash.create('success', 'Attachment successfully deleted.');
          vm.webinar.attachments.splice(vm.webinar.attachments.indexOf(attachment), 1);
        }
      );
    }

    function saveTopics() {
      cmsWebinarService(sessionService.getAuthToken()).saveTopics({id: $stateParams.id}, {topic_ids: vm.webinar.topic_ids}, _response => {
        Flash.create('success', 'Topics successfully updated.');
      });
    }

    function updateWebinar() {
      cmsWebinarService(sessionService.getAuthToken()).update({id: $stateParams.id}, vm.webinar, _updateWebinarSuccess, _updateWebinarFailure);
    }

    function uploadAttachment(attachment) {
      attachment.upload = Upload.upload({
        url: `${config.complianceServicesApiEndpoint}/api/cms/webinars/${$stateParams.id}/attachments`,
        method: 'POST',
        data: {title: 'Attachment', asset: attachment},
        headers: {
          'Authorization': `Token token=${sessionService.getAuthToken()}`
        }
      });

      attachment.upload.then(response => {
        $timeout(() => {
          vm.webinar.attachments.push(response.data);
          Flash.create('success', 'Attachment successfully uploaded.');
        });
      }, _response => {
        Flash.create('danger', 'An unexpected error occurred uploading attachment.');
      });
    }

    function uploadVideo(video) {
      vm.uploadVideoProgress = 0;

      video.upload = Upload.upload({
        url: `${config.complianceServicesApiEndpoint}/api/cms/webinars/${vm.webinar.id}/video`,
        method: 'POST',
        data: {video: video},
        headers: {
          'Authorization': `Token token=${sessionService.getAuthToken()}`
        }
      });

      vm.videoUploading = true;

      video.upload.then(response => {
        $timeout(() => {
          vm.videoUploading = false;
          vm.webinar.video_url = response.data.video_url;
          Flash.create('success', 'Video successfully updated.');
        });
      }, _response => {
        vm.videoUploading = false;
        Flash.create('danger', 'An unexpected error occurred uploading video.');
      }, evt => {
        vm.videoUploadProgress = parseInt(100.0 * evt.loaded / evt.total);
      });
    }

    function _deleteVideoSuccess(response) {
      Flash.create('success', 'Video successfully removed.');
      vm.webinar.video_url = response.video_url;
    }

    function _deleteVideoFailure(error) {
      Flash.create('danger', 'An error occurred deleting the video.');
      vm.setFormErrors(vm.webinarForm, error);
    }

    function _deleteWebinarFailure() {
      Flash.create('danger', 'An error occurred deleting the webinar. Please try again later.');
    }

    function _deleteWebinarSuccess() {
      $state.go('application.compliance_services.cms_list_webinars');
      Flash.create('success', 'The webinar was successfully deleted.');
    }

    function _updateWebinarFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      vm.setFormErrors(vm.webinarForm, response);
    }

    function _updateWebinarSuccess(response) {
      Flash.create('success', `${response.title} was successfully updated.`);
    }
  }
})();
